import { Slide } from '@features/powerpoint';
import { DEFAULT_SLIDE_MASTER } from '../../../slides/slide-master';
import {
  CampaignAnalyticsReport,
  NameValuePairWithSortIndex,
} from '@components/Dashboard/CampaignAnalytics/slice/schema';
import { shapes } from './demographic-profile/shapes';
import { charts } from './demographic-profile/charts';
import { texts } from './demographic-profile/texts';
import { sortBy } from '@utils/arrays';
import {
  AGE_RANGE,
  CHILDREN_STATUS,
  EDUCATION,
  GENDER,
  HOMEOWNERSHIP,
  HOUSEHOLD_INCOME,
  MARITAL_STATUS,
  PETS,
} from '@constants/campaign-analytics';

type DemographicProfileSlideOptions = {
  demographicProfile: CampaignAnalyticsReport['demographicProfile'];
};

export const demographicProfileChartConfiguration = (
  demographicProfile: CampaignAnalyticsReport['demographicProfile']
): DemographicProfileChartConfiguration => {
  const visitData = demographicProfile.data.visited;
  return [
    { title: GENDER, stats: visitData.statsByGender },
    { title: MARITAL_STATUS, stats: visitData.statsByMaritalStatus },
    { title: CHILDREN_STATUS, stats: visitData.statsByChildrenPresence },
    { title: HOMEOWNERSHIP, stats: visitData.statsByHomeownership },
    { title: EDUCATION, stats: visitData.statsByEducation },
    { title: PETS, stats: visitData.statsByPets },
    { title: AGE_RANGE, stats: visitData.statsByAge },
    { title: HOUSEHOLD_INCOME, stats: visitData.statsByIncome },
  ]
    .filter(stats => stats.stats.length > 0)
    .map(profile => ({
      ...profile,
      stats: profile.stats.toSorted(sortBy('sortIndex')),
    }));
};

export type DemographicProfileChartConfiguration = {
  title: string;
  stats: NameValuePairWithSortIndex[];
}[];

export const demographicProfileSlide = (
  options: DemographicProfileSlideOptions
): Slide => {
  const chartConfig = demographicProfileChartConfiguration(
    options.demographicProfile
  );

  return {
    slideMaster: DEFAULT_SLIDE_MASTER,
    texts: texts({ chartConfig }),
    shapes: shapes({ chartConfig }),
    charts: charts({ chartConfig }),
  };
};
